export enum HealthConditionsDataIndex {
  'health_condition' = 'health_condition',
  'description' = 'description',
}
